const API = {
  POST_CREATE_SESSION: {
    path: '/session/create',
    method: 'POST',
  },
  POST_UPDATE_SESSION: {
    path: '/session/update',
    method: 'POST',
  },
  GET_FETCH_GROUPS: {
    path: '/group/details/expert',
    method: 'GET',
  },
  GET_FETCH_SESSIONS: {
    path: '/session/search',
    method: 'GET',
  },
  GET_FETCH_SESSION_DETAILS: {
    path: '/session/details',
    method: 'GET',
  },
  GET_CATEGORIES: {
    path: '/categories',
    method: 'GET',
  },
  POST_ASSIGN_CATEGORIES: {
    path: '/categories/assign',
    method: 'POST',
  },
  POST_BULK_CANCEL_SESSION: {
    path: '/session/cancel-bulk',
    method: 'POST',
  },
  GET_PREQUISITE_SEARCH: {
    path: '/session/course-search',
    method: 'GET',
  },
  POST_SESSION_RECORDING_SHARE: {
    path: '/session/share-recording',
    method: 'POST',
  },
};
export default API;
